module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickbox-step-title"
  }, [_c('div', {
    staticClass: "klickbox-edit-title"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('general.labels.title')) + "\n  ")]), _vm._v(" "), _c('text-editor', {
    attrs: {
      "content": _vm.step.title,
      "change": _vm.onChange,
      "placeholder": _vm.$t('edit.canvas.question_title_placeholder')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "klickbox-step-bar"
  })], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-25d978a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/Title.vue
 ** module id = 782
 ** module chunks = 1
 **/